<ng-container *ngIf="profileField$ | async as profileField">
    <ng-container *ngIf="profileField.FieldDefinition.Values?.length > 3; then select; else radio"></ng-container>

    <ng-template #select>
        <sh-form-multi-select
            [id]="profileField.FieldDefinition.FlatKey"
            [label]="profileField.DisplayLabel"
            [labelIcons]="labelIcons"
            [helpText]="profileField.Description"
            [options]="selectOptions$ | async"
            [control]="control$ | async"
            [errorMsg]="(errorMsg$ | async) || '' | translate"
            [canBeIndeterminate]="canBeIndeterminate"
            [indeterminateMsg]="'general.different-values' | translate"
            [searchPlaceholderMsg]="'ui.search' | translate"
            [noResultsFoundMsg]="'ui.no-results' | translate"
            [listCappedMsg]="'ui.capped-results' | translate"
            [multiple]="false"
            [search]="true"
            [disabledMsg]="disabledMessageKey | translate"
            (searchTerm)="onSearchTermChange($event)"
        >
            <ng-container [ngTemplateOutlet]="batchMode"></ng-container>
        </sh-form-multi-select>
    </ng-template>
    <ng-template #radio>
        <sh-form-radio-list
            [id]="profileField.FieldDefinition.FlatKey"
            [label]="profileField.DisplayLabel"
            [labelIcons]="labelIcons"
            [helpText]="profileField.Description"
            [items]="radioOptions$ | async"
            [control]="control$ | async"
            [errorMsg]="(errorMsg$ | async) || '' | translate"
            [canBeIndeterminate]="canBeIndeterminate"
            [indeterminateMsg]="'general.different-values' | translate"
            [disabledMsg]="disabledMessageKey | translate"
            [clearable]="clearable"
        >
            <ng-container [ngTemplateOutlet]="batchMode"></ng-container>
        </sh-form-radio-list>
    </ng-template>

    <ng-template #batchMode>
        <ng-content></ng-content>
    </ng-template>
</ng-container>
